import { WithSymbol, WithTemplate } from './layer.model';

export type TrimbleLayerApiModel = {
  id: number;
  color: string;
  displayPriority: number;
  lineweight: number;
  isPrint: boolean;
  isProtected: boolean;
  groupLayer: string;
  layer: { id: number };
};

export type WithLayer = TrimbleLayerApiModel & { layer: WithTemplate & WithSymbol };

export enum TrimbleLayerRelationship {
  LAYER = 'LAYER',
  SYMBOL = 'SYMBOL',
  TEMPLATE = 'TEMPLATE',
}
